import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Switch } from "../../../../dynamic-forms/inputs/switch/switch.model";

@Component({
  selector: "app-risk-overread-claim-deficiency",
  templateUrl: "./risk-overread-claim-deficiency.component.html",
  styleUrls: [
    "../../../../dynamic-forms/inputs/textbox/textbox.component.scss",
    "./risk-overread-claim-deficiency.component.scss",
  ],
})
export class RiskOverreadClaimDeficiencyComponent implements OnInit {
  @Input() isRiskProject: boolean;
  @Input() overreadIEnabled: Switch;
  @Input() overreadIIEnabled: Switch;
  @Input() projectSettingsFormGroup: FormGroup;
  @Input() riskFormGroup: FormGroup;
  @Input() projectConfigForm: FormGroup;
  @Input() trackByIndex: (index: number, obj: any) => any;

  @Output() deficientChaseBlur = new EventEmitter<{ group: string; index: number }>();

  constructor() {}

  get overread1Description(): string {
    return "This setting initiates review on first-pass coding.";
  }

  get overread2Description(): string {
    return "This setting enables secondary review which occurs Overread I";
  }

  ngOnInit(): void {}
}
